<ion-progress-bar *ngIf="showProgressBar" [value]="progress"></ion-progress-bar>

<!-- Contenedor principal del swiper, pantalla completa -->
<div *ngIf="show" id="swiper" class="swiper-container full-screen" #swiper>
  <div class="swiper-wrapper centered">
    <ng-content></ng-content>
  </div>

  <!-- Paginación de swiper -->
  <div class="swiper-pagination"></div>
</div>

<!-- Botones de navegación -->
<div *ngIf="showButtons" class="swiper-buttons ion-padding-horizontal">
  <ion-button (click)="prev()" [disabled]="progress === 0" fill="clear" shape="round" expand="block">
    <ion-icon slot="start" name="arrow-back"></ion-icon> Anterior
  </ion-button>

  <ion-button (click)="next()" [disabled]="progress === 1" fill="clear" shape="round" expand="block">
    Siguiente <ion-icon slot="end" name="arrow-forward"></ion-icon>
  </ion-button>
</div>
